var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"title":"Can Use Sticky"}},[_c('demo-card',{attrs:{"title":"暂无示例"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }